/**
 * @class Currency
 */
export default class Currency {
    /**
     * @param {Number}  id
     * @param {String}  name
     * @param {String}  code
     * @param {String}  symbol
     * @param {Number}  rate
     * @param {Number}  rounding
     * @param {Boolean} visible
     * @param {Boolean} local
     * @param {Boolean} primary     If true, other currencies rate is given relative to this currency
     */
    constructor(id, name, code, symbol, rate, rounding, visible, local, primary) {
        this._id = id;
        this._name = name;
        this._code = code;
        this._symbol = symbol;
        this._rate = rate;
        this._rounding = rounding;
        this._visible = visible;
        this._local = local;
        this._primary = primary;

        if (typeof this._id !== "number") {
            throw new Error("Invalid datatype of ID - Currency");
        }
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number}  id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {String}
     */
    get name() {
        return this._name;
    }

    /**
     * @param {String}  name
     */
    set name(name) {
        this._name = name;
    }

    /**
     * @return {String}
     */
    get code() {
        return this._code;
    }

    /**
     * @param {String} code
     */
    set code(code) {
        this._code = code;
    }

    /**
     * @return {String}
     */
    get symbol() {
        return this._symbol;
    }

    /**
     * @param {String} symbol
     */
    set symbol(symbol) {
        this._symbol = symbol;
    }

    /**
     * @return {Number}
     */
    get rate() {
        return this._rate;
    }

    /**
     * @param {Number} rate
     */
    set rate(rate) {
        this._rate = rate;
    }

    /**
     * @return {Number}
     */
    get rounding() {
        return this._rounding;
    }

    /**
     * @param {Number}  rounding
     */
    set rounding(rounding) {
        this._rounding = rounding;
    }

    /**
     * @return {Boolean}
     */
    get visible() {
        return this._visible;
    }

    /**
     * @param {Boolean}  visible
     */
    set visible(visible) {
        this._visible = visible;
    }

    /**
     * @return {Boolean}
     */
    get local() {
        return this._local;
    }

    /**
     * @param {Boolean}  local
     */
    set local(local) {
        this._local = local;
    }

    /**
     * @return {Boolean}
     */
    get primary() {
        return this._primary;
    }

    /**
     * @param {Boolean}  primary
     */
    set primary(primary) {
        this._primary = primary;
    }

    /**
     * @return {String}
     */
    toString() {
        return "Currency (" + this._id + ")";
    }
}
